export const DEFAULT_ADVANCE_TIME = 4320;

export const DEFAULT_RECEIPT_TYPES = ["sendUpdates", "sendCancellations"];
